import { render, staticRenderFns } from "./breadcrump.vue?vue&type=template&id=dddd245e&scoped=true"
import script from "./breadcrump.vue?vue&type=script&lang=js"
export * from "./breadcrump.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddd245e",
  null
  
)

export default component.exports